//
import React from 'react'

import { useOtDispatch, useOtSelector } from '@react/redux/store'
import { createClientWebsocketHandler } from '@react/redux/wsClient'
import { logOT } from '@shared/loggingShared'

import Backdrop from '@mui/material/Backdrop'

export const WebsocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }): React.ReactElement => {
  const { stageConfiguration, wsIsConnected, chainConfiguration } = useOtSelector((state) => state.chainState)
  const chainConfigurationName = chainConfiguration?.chainConfigurationName
  const websocketUrl = stageConfiguration.websocketUrl

  const [hasStarted, setHasStarted] = React.useState(false)
  const [reconnecting, setReconnection] = React.useState(false)

  const dispatch = useOtDispatch()

  const reConnectIfIdle = () => {
    logOT.info(
      'WebsocketProvider reConnectIfIdle LastActionTime',
      websocketUrl,
      hasStarted,
      chainConfigurationName,
      !wsIsConnected,

      !reconnecting,
      websocketUrl && !wsIsConnected && chainConfigurationName && !reconnecting
    )
    if (websocketUrl && !wsIsConnected && chainConfigurationName && !reconnecting) {
      logOT.debug('WebsocketProvider reConnectIfIdle LastActionTime')
      setReconnection(true)
      setHasStarted(true)
      createClientWebsocketHandler(websocketUrl, dispatch, chainConfigurationName)
        .then((_webSocket) => {
          setReconnection(false)
        })
        .finally(() => {
          logOT.debug('WebsocketProvider reConnectIfIdle finally inProcessOfConnecting')
          setHasStarted(false)
          setReconnection(false)
        })
    }
  }

  return (
    <>
      {children}
      <Backdrop
        sx={{ color: '#fff', zIndex: 5, display: 'block' }}
        open={!wsIsConnected}
        onMouseMove={reConnectIfIdle}
      ></Backdrop>
    </>
  )
}
